(() => {
  if (customElements.get('rnf-automatic-badges')) return;
  const records = new Map();
  const photoTones = {
    '3_891b9146-ba97-4594-accd-d92f22236554.webp?v=1792158828':3,
    '4_123f1cd4-c564-49f1-a656-dffa89fb0441.webp?v=1792158828':3,
    '5_24be1456-89cf-4af1-a84d-88f5cac171c0.webp?v=1792158827':2,
    '7_0cb167b6-1f69-4982-9926-8865c8481fae.webp?v=1792158827':3,
    '9_db33055b-2af3-45cc-a12b-cf9d0f35bbbd.webp?v=1792158827':3,
    '1_bad90063-4301-4685-aad0-9f2d20cb6a88.webp?v=1786555754':3,
    '2_51edba79-6d23-4a2b-b415-f4c20d74afe2.webp?v=1786555754':2,
    '4_68563b09-0ac6-4170-b6ae-d4f20f7d760b.webp?v=1786555755':3,
    '5_7d6d7799-d317-42db-93fa-cfae64570731.webp?v=1786555755':3,
    '6_6450e99c-7071-4b5a-971f-254655ea931b.webp?v=1786555754':1,
    '10_d157a8c4-16f0-47e8-83e8-0db4c4a6f581.webp?v=1786561183':3,
    '11_7f66c7f6-f7f0-47b4-9764-3eb87ec933b1.webp?v=1786561184':2,
    '4_1.webp?v=1786561184':3,
    '6_1.webp?v=1786561184':3,
    '7_1.webp?v=1786561184':3,
    '9_1_c125df89-9288-48c1-b64e-7bcf552c1c39.webp?v=1786561184':3
  };
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const badge = records.get(entry.target);
      if (!badge) continue;
      badge.visible = entry.isIntersecting && entry.intersectionRatio >= .2;
      badge.sync();
    }
  }, { rootMargin: '0px', threshold: [0,.2] }) : null;
  const sync = () => records.forEach(badge => badge.sync());
  class AutomaticBadges extends HTMLElement {
    connectedCallback() {
      if (this.media) return;
      this.media = this.closest('[data-rnf-automatic-media]');
      if (!this.media) return;
      this.photo = this.media.matches('.card__media') ? this.media.querySelector('.media') || this.media : this.media;
      this.visible = false;
      this.context = new MutationObserver(() => { this.sync(); this.syncTone(); });
      this.context.observe(this.photo,{attributes:true,attributeFilter:['data-rnf-preview-index']});
      this.onPhotoChange = () => this.syncTone();
      this.onPhotoLoad = event => { if (event.target.tagName === 'IMG' && !this.contains(event.target)) this.syncTone(); };
      this.media.addEventListener('rnf:preview:start',this.onPhotoChange);
      this.media.addEventListener('rnf:preview:end',this.onPhotoChange);
      this.media.addEventListener('load',this.onPhotoLoad,true);
      if (this.media.hasAttribute('data-rnf-automatic-gallery')) {
        this.galleryList = this.media.querySelector('.product__media-list');
        this.galleryContext = new MutationObserver(() => {
          this.activeSlide = null;
          this.watchGallerySlides();
          this.syncTone();
        });
        if (this.galleryList) this.galleryContext.observe(this.galleryList,{childList:true});
        this.watchGallerySlides();
        this.onSlideChange = event => {
          const slide = event.detail?.currentElement;
          if (!slide || !this.galleryList?.contains(slide)) return;
          this.activeSlide = slide;
          this.syncTone();
        };
        this.media.addEventListener('slideChanged',this.onSlideChange);
      }
      let parent = this.media.parentElement;
      while (parent) {
        if (parent.matches('details,dialog,.rnf-tab-panel,[aria-hidden]')) this.context.observe(parent,{attributes:true,attributeFilter:['open','hidden','aria-hidden','class']});
        parent = parent.parentElement;
      }
      records.set(this.media,this);
      observer?.observe(this.media);
      this.syncTone();
      this.sync();
    }
    watchGallerySlides() {
      if (!this.galleryList) return;
      for (const slide of this.galleryList.children) this.galleryContext.observe(slide,{attributes:true,attributeFilter:['class']});
    }
    syncTone() {
      const track = this.photo.querySelector('.rnf-nav-preview-track');
      const index = Number(this.photo.dataset.rnfPreviewIndex || 0);
      const slide = this.galleryList && (this.activeSlide?.isConnected && this.galleryList.contains(this.activeSlide) ? this.activeSlide : this.galleryList.querySelector('.is-active') || this.galleryList.firstElementChild);
      const image = slide ? slide.querySelector('.product__media img, img') : track?.children[index] || this.photo.querySelector(':scope > img, .product__media img');
      let tone = 0;
      if (image) {
        try {
          const url = new URL(image.currentSrc || image.getAttribute('src'),location.href);
          tone = photoTones[`${url.pathname.split('/').pop()}?v=${url.searchParams.get('v') || ''}`] || 0;
        } catch {}
      }
      this.classList.toggle('is-dark-spin-label',!!(tone & 1));
      this.classList.toggle('is-dark-automatic-label',!!(tone & 2));
    }
    sync() {
      if (!this.media) return;
      const blocked = this.media.closest('[hidden],details:not([open]),dialog:not([open]),[aria-hidden="true"]');
      const panel = this.media.closest('.rnf-tab-panel');
      const visible = this.visible && !blocked && (!panel || panel.classList.contains('is-active'));
      this.classList.toggle('is-running',!!(visible && this.isConnected && !document.hidden && !reduced.matches));
    }
    disconnectedCallback() {
      if (!this.media) return;
      observer?.unobserve(this.media);
      records.delete(this.media);
      this.context?.disconnect();
      this.galleryContext?.disconnect();
      if (this.onSlideChange) this.media.removeEventListener('slideChanged',this.onSlideChange);
      this.media.removeEventListener('rnf:preview:start',this.onPhotoChange);
      this.media.removeEventListener('rnf:preview:end',this.onPhotoChange);
      this.media.removeEventListener('load',this.onPhotoLoad,true);
      this.classList.remove('is-running');
      this.media = null;
      this.photo = null;
      this.galleryList = null;
      this.activeSlide = null;
    }
  }
  customElements.define('rnf-automatic-badges',AutomaticBadges);
  document.addEventListener('visibilitychange',sync);
  reduced.addEventListener('change',sync);
})();
